export default __webpack_public_path__ + "static/media/B191.e003bea1.png";